import React, { PureComponent } from "react";
import styled from "styled-components";
import Select from "react-select";
import { Header, Icon, Breadcrumb, Loader, Loading, DateInput,Note,TableWrapper } from "../components";
import { Formik, Field } from "formik";
import { Link } from "react-router-dom";
import get from "lodash/get";
import map from "lodash/map";
import values from "lodash/values";
import remove from "lodash/remove";
import isEmpty from "lodash/isEmpty";
import { toast } from "react-toastify";
import uuidv4 from "uuid";
import * as _ from "lodash";
import * as moment from "moment";
import axios from "axios";
import { API_URL,FILE_PATH } from "../constants";
import * as Yup from "yup";

const VisitorFormSchema = Yup.object().shape({
  project: Yup.object({
    value: Yup.string().nullable().trim().required("Project Field is Required"),
  }),
  description: Yup.string()
    .nullable()
    .trim()
    .required("Description field is Required"),
});

const Container = styled.div`
  width: 100%;
  padding: 50px 16px 16px 16px;
  max-width: 800px;
  margin: auto;
`;
const Title = styled.p`
  margin: 0px;
  padding: 10px 0 3px 0;
`;
 
const ImageUpload = styled.div`
  display: flex;
  flex-wrap: wrap;
`;
const InputWrapper = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 4px;
  margin: 0px 10px 10px 0px;
  background: #f3f3f3;
  border: 1px solid #f1f1f1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 20px;
  color: #020266;
  position: relative;
  & input {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
  }
  & img {
    width: 50px;
    transform: scale(1.3);
  }
  & div {
    width: 100%;
    overflow: hidden;
  }
`;
const DeleteIcon = styled.label`
  position: absolute;
  z-index: 99;
  right: -5px;
  top: -5px;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 2px;
`;



const ImageContainer = styled.div`
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const TextArea = styled.textarea`
  border: 1px solid hsl(0, 0%, 80%);
  border-radius: 4px;
  width: 100%;
`;
const ButtonWrapper = styled.div`
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Wrapper = styled.div`
  display: flex;
  padding: 8px 0px;
  & > div {
    width: ${(props) => (props.width ? props.width : "50%")};
    &:first-child {
      padding-right: 6px;
    }
    &:nth-child(2) {
      padding-left: 6px;
    }
  }
`;
const Button = styled.button`
  padding: 10px 25px;
  background: #020266;
  border: 1px solid #020266;
  border-radius: 4px;
  color: #fff;
  margin: 0 5px;
`;

const ComponentCircle = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: ${props=> props.selected ? '#fff' : 'transparent'};
  border-radius: 4px;
  padding: 4px 0px;
  & p {
    margin: 0px;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 600;
    margin-bottom: 4px;

  }
  & img {
    width: 50px;
    height: 50px;
    overflow: hidden;
    border-radius: 50%;
    box-shadow: 0px 1px 2px 0px #ccc;
  }
`;

class VisitorForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      states: [],
      isLoading: true,
      imageuploadIdz: [],
      reportsuploadIdz:[],
      selectedComponent:'',
      permission:{}
    };
  }

  componentDidMount = async () => {
    // state api calls
    const { data } = await axios.get("/states");
    const { data: permission } = await axios.get(`/dashboard/permission`)

    // const { data: components } = await axios.get("/component");
    this.setState({
      states: map(data, (obj) => ({
        label: obj.statename,
        value: obj.statecode,
      })),
      permission,
      // componentList: map(components, (obj) => ({ label: obj, value: obj })),
      isLoading: false,
    });
  };

  handleSaveDraft = (data) => {
    if (!_.isEmpty(this.state.imageuploadIdz)) {
      toast("Image Uploading..., Please wait.", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      return;
    }
    if (!isEmpty(data)) {
      localStorage.setItem(
        "draft",
        JSON.stringify({
          ...data,
          id: uuidv4(),
          createdAt: moment().format("DD-MMM-YYYY"),
        })
      );
      toast("Saved Draft Successfully ! ", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
      this.props.history.push("/");
    } else {
      toast("Empty form not be accepted ! ", {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  render() {
    const { states, imageuploadIdz,reportsuploadIdz,selectedComponent,permission } = this.state;
    const { match } = this.props;
    const localData = get(match, "params.id")
      ? JSON.parse(localStorage.getItem("editData"))
      : JSON.parse(
          localStorage.getItem("draft") ? localStorage.getItem("draft") : "{}"
        );

    const AnxFiles = _.get(localData,'project.PDF') ? JSON.parse(_.get(localData,'project.PDF') || '[]') :[]
    // console.log('localData------->>', {localData,AnxFiles})

    const filteredState= _.get(permission,'data.type')==='admin' ? states :  _.get(permission,'data.type')!=='admin' && _.isEmpty(_.get(permission,'data.allowState')) ? states : _.filter(states,f=>_.get(permission,'data.allowState').indexOf(f.value)!==-1)

    return (
      <React.Fragment>
        {this.state.isLoading && <Loader />}
        <Header />
        <Container>
          <Breadcrumb>
            <Link to="/">Home</Link>
            <Icon icon="rightArrow" width={10} height={10} />
            Inspection Form
            {_.get(match, "params.id") && (
              <React.Fragment>
                <Icon icon="rightArrow" width={10} height={10} />
                Update
              </React.Fragment>
            )}
          </Breadcrumb>

          <Formik
            enableReinitialize={true}
            validationSchema={VisitorFormSchema}
            initialValues={
              localData
                ? localData
                : {
                    state: "",
                    component: "",
                    cityLoading: false,
                    cityList: [],
                    city: "",
                    projectLoading: false,
                    projectList: [],
                    project: "",
                    VisitedDate:'',
                    imagesFile: [],
                    reportsFile:[],
                    videosFile: [],
                    audiosFile: [],
                    description: "",
                  }
            }
            onSubmit={async (input, { resetForm, setValues }) => {
              // console.log('input------->>', input)
              // return null
              if (!_.isEmpty(imageuploadIdz)) {
                toast("Image Uploading..., Please wait.", {
                  position: toast.POSITION.BOTTOM_CENTER,
                });
                return;
              }

              const data = {
                StateName: get(input, "state.label"),
                StateCode: get(input, "state.value"),
                Component: get(input, "component.label"),
                DistrictName: get(input, "district.label"),
                DistrictCode: get(input, "project.DistrictCode"),
                CityName: get(input, "city.label"),
                CityCode: get(input, "city.value"),
                ProjectCode: get(input, "project.value"),
                VisitedDate: get(input, "VisitedDate"),
                ProjectTitle: get(input, "project.label"),
                Description: get(input, "description"),
                BeneficiaryCode: get(input, "project.beneficiaryCode"),
                imageUrl: values(get(input, "imagesFile")),
                reportsUrl: values(get(input, "reportsFile")),
                audioUrl: values(get(input, "audiosFile")),
                videoUrl: values(get(input, "videosFile")),
                Houses: Number(get(input, "project.HousesSanctionedNew", 0))+Number(get(input, "project.HousesSanctionedEnahncement", 0)),
                updatedAt: moment(new Date()).format("YYYY-MM-DD hh:ss:mm"),
              };

              if (get(match, "params.id")) {
                // console.log('update--------->>', data)
                await axios
                  .post(`/visitor/update/${get(match, "params.id")}`, data)
                  .then((res) => {
                    this.props.history.push("/");
                    localStorage.setItem("editData", "");
                    toast("Form Updated Successfully ! ", {
                      position: toast.POSITION.BOTTOM_CENTER,
                    });
                  })
                  .catch((err) => {
                    toast("Form Not Updated Successfully ! ", {
                      position: toast.POSITION.BOTTOM_CENTER,
                    });
                  });
              } else {
                await axios
                  .post("/visitor", data)
                  .then((res) => {
                    this.props.history.push("/");
                    localStorage.setItem("draft", "");
                    toast("Form Submit Successfully ! ", {
                      position: toast.POSITION.BOTTOM_CENTER,
                    });
                  })
                  .catch((err) => {
                    toast("Form Not Submit Successfully ! ", {
                      position: toast.POSITION.BOTTOM_CENTER,
                    });
                  });
              }
            }}
          >
            {(formikBag) => {

              const projectList = formikBag.values.projectList
              const groupByComponent = _.groupBy(projectList, 'Component')
              // console.log('formikBag----->>>', formikBag.values)
              return (
                <form
                  onSubmit={(event) => {
                    event.preventDefault();
                    formikBag.validateForm().then((errors) => {
                      const errKeys = Object.keys(errors);
                      // console.log({errors, errKeys})
                      if (errKeys.length > 0) {
                        const errMessage =
                          typeof errors[errKeys[0]] === "string"
                            ? errors[errKeys[0]]
                            : errors[errKeys[0]]["value"];
                        // console.log('errMessage---->>', errMessage)
                        toast(errMessage, {
                          position: toast.POSITION.BOTTOM_CENTER,
                        });
                        return null;
                      } else {
                        return formikBag.handleSubmit();
                      }
                    });
                  }}
                >
                  {_.isEmpty(localData)?<>
                  <Wrapper>
                    <div>
                      <Field
                        name="state"
                        render={({ field, form }) => (
                          <Select
                            {...field}
                            options={filteredState}
                            placeholder={"Select State"}
                            value={formikBag.values.state}
                            isDisabled={get(match, "params.id") ? true : false}
                            onChange={async (values) => {
                              formikBag.setValues({ districtLoading: true });
                              const { data: city } = await axios.get(
                                `/city/state/${values.value}`
                              );
                              // console.log('city---->', city)
                              formikBag.setValues({
                                ...formikBag.values,
                                state: values,
                                component: "",
                                city: "",
                                project: "",
                                cityList: map(city, (obj) => ({
                                  value: obj.CityCode,
                                  label: obj.CityName,
                                })),
                                cityLoading: false,
                              });
                            }}
                          />
                        )}
                      />
                    </div>

   
                    <Field
                      name="city"
                      render={({ field, form }) => (
                        <Select
                          {...field}
                          placeholder={"Select City"}
                          isLoading={formikBag.values.cityLoading}
                          isDisabled={get(match, "params.id") ? true : false}
                          options={formikBag.values.cityList}
                          value={formikBag.values.city}
                          onChange={async (values) => {
                            formikBag.setValues({
                              ...formikBag.values,
                              projectLoading: true,
                            });
                            const { data: project } = await axios.get(
                              `/project-details/${get(
                                formikBag.values,
                                "state.value"
                              )}/${values.value}`
                            );
                            formikBag.setValues({
                              ...formikBag.values,
                              projectLoading:false,
                              city: values,
                              project: "",
                              projectList: map(project, (obj) => ({
                                ...obj,
                                value: obj.ProjectCode,
                                label: `CSMC Date:${moment(obj.CSMCDate).format(
                                  "DD-MMM-YYYY"
                                )}, CSMC No:${obj.CSMCNo}, Houses: ${(
                                  Number(obj.HousesSanctionedNew) +
                                  Number(obj.HousesSanctionedEnahncement)
                                ).toLocaleString("en-in")}`,
                              })),
                              cityLoading: false,
                            });
                          }}
                        />
                      )}
                    />
                  </Wrapper>
                 {_.get(projectList,'length') ? <Wrapper>
                      {
                        _.map(groupByComponent,(cmpt,i)=>{
                          // console.log({cmpt,i})
                          const scheme = _.get(cmpt,'0.Scheme')
                          const color = _.get(cmpt,'0.Scheme') ==='RAY' ? 'rgb(121,52,43)' : _.get(cmpt,'0.Scheme') ==='PMAY-U' ? '#dc8138' :  _.get(cmpt,'0.Scheme') ==='JnNURM' ? 'blue' :  '#000'
                          return(
                            <ComponentCircle key={i} selected={selectedComponent === i} onClick={()=>this.setState({selectedComponent: selectedComponent === i ? '' : i})}>
                            <p style={{color:color}}>{i}({`${_.get(cmpt,'length')}`})</p>
                            <img
                              alt={"component"}
                              src={require(`../static/${scheme}.jpg`)}
                            />
                          </ComponentCircle>
                          )
                        })
                      }
                  </Wrapper> :''}
                  <Wrapper width="100%">
                    <Field
                      name="project"
                      render={({ field, form }) => (
                        <Select
                          {...field}
                          placeholder={"Select Project"}
                          isLoading={formikBag.values.projectLoading}
                          isDisabled={get(match, "params.id") ? true : false}
                          options={selectedComponent ? _.filter(formikBag.values.projectList, flt=> selectedComponent === flt.Component) : formikBag.values.projectList }
                          value={formikBag.values.project}
                          onChange={async (values) => {
                            formikBag.setValues({
                              ...formikBag.values,
                              project: values,
                            });
                          }}
                        />
                      )}
                    />
                  </Wrapper>
                  </> :
                  // Annexuer Files
                  <TableWrapper>
                        <div>
                        Attached 7A,7B or 7C
                        </div>
                        <table border="1px" border-colapse={"colapse"}>
                          <tbody>
                            {_.map(AnxFiles,(fl,i)=>{
                              return(
                                <tr>
                                  <td style={{width:50,mxWidth:50}}>{i+1}</td>
                                  <td><a target='_blank' rel="noopener noreferrer" href={`${FILE_PATH}/AnnexureFile/${fl}`}>{fl}</a></td>
                                </tr>
                              )
                            })}
                          </tbody>
                        </table>
                      </TableWrapper>

                  }
                  {/* Note */}
                  {get(formikBag.values, "project.ProjectTitle", "") ? (
                    <Note>
                      <span>Note:</span>
                      {get(formikBag.values, "project.ProjectTitle", "")}
                    </Note>
                  ) : (
                    ""
                  )}

                  {/* Table */}
                  {get(formikBag.values, "project.label", "") ? (
                    <>
                      <TableWrapper>
                        <div>
                          {" "}
                          Financial Progress <span>(in Cr.)</span>
                        </div>
                        <table border="1px" border-colapse={"colapse"}>
                          <thead>
                            <tr>
                              <td>Invesment</td>
                              <td>CA Approved</td>
                              <td>CA Released</td>
                              <td>UC Pending</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {Number(
                                  get(
                                    formikBag.values,
                                    "project.ProjectCost",
                                    0
                                  )
                                )
                                  ? Number(
                                      get(
                                        formikBag.values,
                                        "project.ProjectCost",
                                        0
                                      )
                                    ).toFixed(2)
                                  : "-"}
                              </td>
                              <td>
                                {Number(
                                  get(
                                    formikBag.values,
                                    "project.CentralAssistApproved",
                                    0
                                  )
                                )
                                  ? Number(
                                      get(
                                        formikBag.values,
                                        "project.CentralAssistApproved",
                                        0
                                      )
                                    ).toFixed(2)
                                  : "-"}
                              </td>
                              <td>
                                {Number(get(formikBag.values,"project.installment1",0))+Number(get(formikBag.values,"project.installment2",0))+Number(get(formikBag.values,"project.installment3",0))+Number(get(formikBag.values,"project.installment4",0))
                                  ? Number(Number(get(formikBag.values,"project.installment1",0))+Number(get(formikBag.values,"project.installment2",0))+Number(get(formikBag.values,"project.installment3",0))+Number(get(formikBag.values,"project.installment4",0))).toFixed(2)
                                  : "-"}
                              </td>
                              <td>
                                {Number(Number(get(formikBag.values,"project.installment1",0))+Number(get(formikBag.values,"project.installment2",0))+Number(get(formikBag.values,"project.installment3",0))+Number(get(formikBag.values,"project.installment4",0))) -
                                Number(Number(get(formikBag.values,"project.uc1",0))+Number(get(formikBag.values,"project.uc2",0))+Number(get(formikBag.values,"project.uc3",0))+Number(get(formikBag.values,"project.uc4",0)))
                                  ? (Number(Number(get(formikBag.values,"project.installment1",0))+Number(get(formikBag.values,"project.installment2",0))+Number(get(formikBag.values,"project.installment3",0))+Number(get(formikBag.values,"project.installment4",0))) -
                                  Number(Number(get(formikBag.values,"project.uc1",0))+Number(get(formikBag.values,"project.uc2",0))+Number(get(formikBag.values,"project.uc3",0))+Number(get(formikBag.values,"project.uc4",0)))) > 0 ? (Number(Number(get(formikBag.values,"project.installment1",0))+Number(get(formikBag.values,"project.installment2",0))+Number(get(formikBag.values,"project.installment3",0))+Number(get(formikBag.values,"project.installment4",0))) -
                                  Number(Number(get(formikBag.values,"project.uc1",0))+Number(get(formikBag.values,"project.uc2",0))+Number(get(formikBag.values,"project.uc3",0))+Number(get(formikBag.values,"project.uc4",0)))).toFixed(2): '-'
                                  : "-"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </TableWrapper>

                      <TableWrapper>
                        <div>
                          {" "}
                          Physical Progress <span>(Nos)</span>
                        </div>
                        <table border="1px" border-colapse={"colapse"}>
                          <thead>
                            <tr>
                              <td>Houses</td>
                              <td>Grounded</td>
                              <td>Completed</td>
                              <td>Occupied</td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                {get(
                                  formikBag.values,
                                  "project.HousesSanctionedEnahncement",
                                  0
                                )+get(
                                  formikBag.values,
                                  "project.HousesSanctionedNew",
                                  "-"
                                )
                                  ? get(
                                      formikBag.values,
                                      "project.HousesSanctionedEnahncement",
                                      "-"
                                    )+get(
                                      formikBag.values,
                                      "project.HousesSanctionedNew",
                                      "-"
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {get(
                                  formikBag.values,
                                  "project.totalWorkOrders",
                                  0
                                )
                                  ? get(
                                      formikBag.values,
                                      "project.totalWorkOrders",
                                      0
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {get(
                                  formikBag.values,
                                  "project.completed",
                                  0
                                )
                                  ? get(
                                      formikBag.values,
                                      "project.completed",
                                      0
                                    )
                                  : "-"}
                              </td>
                              <td>
                                {get(
                                  formikBag.values,
                                  "project.occupied",
                                  0
                                )
                                  ? get(
                                      formikBag.values,
                                      "project.occupied",
                                      0
                                    )
                                  : "-"}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </TableWrapper>
                    </>
                  ) : (
                    ""
                  )}

                  <DateInput
                    label="Inspection Date"
                    selected={get(
                      formikBag.values,
                      `VisitedDate`,
                      ""
                    )}
                    onChange={(e) => {
                      formikBag.setFieldValue("VisitedDate", e);
                    }}
                  />

                  {/* image section */}
                  <Title>Upload Images</Title>
                  <ImageUpload>
                    {map(
                      [...values(formikBag.values.imagesFile), {}],
                      (item, idx) => {
                        return (
                          <InputWrapper key={idx}>
                            {item.fileName ||
                            imageuploadIdz.indexOf(idx) >= 0 ? (
                              <React.Fragment>
                                <DeleteIcon
                                  onClick={() => {
                                    const imgFiles = remove(
                                      values(formikBag.values.imagesFile),
                                      (items, i) => {
                                        return idx !== i;
                                      }
                                    );
                                    formikBag.setFieldValue(
                                      "imagesFile",
                                      imgFiles
                                    );
                                  }}
                                >
                                  <Icon
                                    icon="cross"
                                    color={"#fff"}
                                    width={12}
                                    height={12}
                                  />
                                </DeleteIcon>
                                <ImageContainer>
                                  {imageuploadIdz.indexOf(idx) >= 0 ? (
                                    <Loading />
                                  ) : (
                                    <img
                                      alt="images"
                                      src={API_URL + "/images/" + item.fileName}
                                    />
                                  )}
                                </ImageContainer>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <input
                                  name="visitorImage"
                                  type="file"
                                  accept="image/*"
                                  onChange={async (e) => {
                                    this.setState({
                                      imageuploadIdz: [...imageuploadIdz, idx],
                                    });
                                    let formData = new FormData();
                                    formData.append(
                                      "visitorImage",
                                      e.target.files[0]
                                    );
                                    formData.append("name", "visitorImage");
                                    await axios
                                      .post("/uploads", formData)
                                      .then((res) => {
                                        this.setState({
                                          imageuploadIdz: _.xor(
                                            [...imageuploadIdz, idx],
                                            [idx]
                                          ),
                                        });
                                        formikBag.setFieldValue("imagesFile", {
                                          ...formikBag.values.imagesFile,
                                          [idx]: res.data,
                                        });
                                      })
                                      .catch((err) => {
                                        this.setState({
                                          imageuploadIdz: _.xor(
                                            [...imageuploadIdz, idx],
                                            [idx]
                                          ),
                                        });
                                        toast(
                                          "Image not Uploaded Successfully ! ",
                                          {
                                            position:
                                              toast.POSITION.BOTTOM_CENTER,
                                          }
                                        );
                                      });
                                  }}
                                />
                                +
                              </React.Fragment>
                            )}
                          </InputWrapper>
                        );
                      }
                    )}
                  </ImageUpload>

                       {/* Upload Reports section */}
                       <Title>Upload Reports</Title>
                  <ImageUpload>
                    {map(
                      [...values(formikBag.values.reportsFile), {}],
                      (item, idx) => {
                        return (
                          <InputWrapper key={idx}>
                            {item.fileName ||
                            reportsuploadIdz.indexOf(idx) >= 0 ? (
                              <React.Fragment>
                                <DeleteIcon
                                  onClick={() => {
                                    const imgFiles = remove(
                                      values(formikBag.values.reportsFile),
                                      (items, i) => {
                                        return idx !== i;
                                      }
                                    );
                                    formikBag.setFieldValue(
                                      "reportsFile",
                                      imgFiles
                                    );
                                  }}
                                >
                                  <Icon
                                    icon="cross"
                                    color={"#fff"}
                                    width={12}
                                    height={12}
                                  />
                                </DeleteIcon>
                                <ImageContainer>
                                  {reportsuploadIdz.indexOf(idx) >= 0 ? (
                                    <Loading />
                                  ) : (
                                    <img alt="images" src={require('../static/doc-flat.png')}/>
                                  )}
                                </ImageContainer>
                              </React.Fragment>
                            ) : (
                              <React.Fragment>
                                <input
                                  name="visitorImage"
                                  type="file"
                                  accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*"                                  
                                  onChange={async (e) => {
                                    this.setState({
                                      reportsuploadIdz: [...reportsuploadIdz, idx],
                                    });
                                    let formData = new FormData();
                                    formData.append(
                                      "visitorImage",
                                      e.target.files[0]
                                    );
                                    formData.append("name", "visitorImage");
                                    await axios
                                      .post("/uploads", formData)
                                      .then((res) => {
                                        this.setState({
                                          reportsuploadIdz: _.xor(
                                            [...reportsuploadIdz, idx],
                                            [idx]
                                          ),
                                        });
                                        formikBag.setFieldValue("reportsFile", {
                                          ...formikBag.values.reportsFile,
                                          [idx]: res.data,
                                        });
                                      })
                                      .catch((err) => {
                                        this.setState({
                                          reportsuploadIdz: _.xor(
                                            [...reportsuploadIdz, idx],
                                            [idx]
                                          ),
                                        });
                                        toast(
                                          "Image not Uploaded Successfully ! ",
                                          {
                                            position:
                                              toast.POSITION.BOTTOM_CENTER,
                                          }
                                        );
                                      });
                                  }}
                                />
                                +
                              </React.Fragment>
                            )}
                          </InputWrapper>
                        );
                      }
                    )}
                  </ImageUpload>

                  {/* onChange={(e)=> formikBag.setFieldValue('imagesFile',{ ...formikBag.values.imagesFile, [idx]:{file:URL.createObjectURL(e.target.files[0])} })} */}

                  {/* <Title>Upload Audio</Title>
        <ImageUpload>
        {map([...values(formikBag.values.audiosFile),{}], (item, idx)=> {
          return(
            <InputWrapper key={idx}> 
              {item.file ?
                <React.Fragment>
                <DeleteIcon onClick={()=> {
                  const auFiles = remove(values(formikBag.values.audiosFile), (items, i) => {
                    return idx !== i
                  })
                  formikBag.setFieldValue('audiosFile', auFiles)
                }}>
                   <Icon icon='cross' color={'#fff'} width={12} height={12} />
                </DeleteIcon>
                  <Icon icon='audio'/>
                </React.Fragment>
                 :<React.Fragment>
                 <input 
                  type='file' 
                  accept="image/*"  
                  onChange={(e)=> formikBag.setFieldValue('audiosFile',{ ...formikBag.values.audiosFile, [idx]:{file:get(e.target,'files.0')} })}
                />+
              </React.Fragment>} 
           </InputWrapper>
          )
        })}
        </ImageUpload>

        <Title>Upload Videos</Title>
        <ImageUpload>
        {map([...values(formikBag.values.videosFile),{}], (item, idx)=> {
          return(
            <InputWrapper key={idx}> 
              {item.file ?
                <React.Fragment>
                <DeleteIcon onClick={()=> {
                  const viFiles = remove(values(formikBag.values.videosFile), (items, i) => {
                    return idx !== i
                  })
                  formikBag.setFieldValue('videosFile', viFiles)
                }}>
                   <Icon icon='cross' color={'#fff'} width={12} height={12} />
                </DeleteIcon>
                  <Icon icon='video'/>
                </React.Fragment>
                 :<React.Fragment>
                 <input 
                  type='file' 
                  accept="image/*"  
                  onChange={(e)=> formikBag.setFieldValue('videosFile',{ ...formikBag.values.videosFile, [idx]:{file:get(e.target,'files.0')} })}
                />+
              </React.Fragment>} 
           </InputWrapper>
          )
        })}
        </ImageUpload> */}

                  <Title>Description</Title>
                  <TextArea
                    value={formikBag.values.description}
                    name="description"
                    onChange={formikBag.handleChange}
                    rows="7"
                  />

                  <ButtonWrapper>
                    <Button
                      type="button"
                      onClick={() => this.handleSaveDraft(formikBag.values)}
                    >
                      Save Draft
                    </Button>
                    <Button type="submit">Submit</Button>
                  </ButtonWrapper>
                </form>
              );
            }}
          </Formik>
        </Container>
      </React.Fragment>
    );
  }
}

export { VisitorForm };
